import { useSelector } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import DashboardNavigator from "./DashboardNavigator";
import AuthNavigator from "./AuthNavigator";

const AppNavigator = () => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  return (
    <Router>{isLoggedIn ? <DashboardNavigator /> : <AuthNavigator />}</Router>
  );
};

export default AppNavigator;
